/* PagingFileFeed.js */

"use strict";
const _ = require("lodash");
const PagingFeed = require("../../../../lib/PagingFeed");
/*
const { OS_IMAGE_STATUS } = require("../../fileConstants");
const hideNotUploaded = (query) => ({
    $and: [
        { status: { $nin: [OS_IMAGE_STATUS.PENDING_UPLOAD, OS_IMAGE_STATUS.UPLOADING] } },
        query || {}
    ]
});
*/

class PagingFileFeed extends PagingFeed {
    _getFeed() {
        return this._EntityDef.startAscendOsImagesFeed(
            this._activeOrgId,
            this._filter, //hideNotUploaded(this._filter)
            this._entityFields,
            this._sort,
            this._initialPage
        );
    }

    _feedReestablish() {
        return new Promise((resolve, reject) =>
            this._feed.reestablishFeed(
                this._activeOrgId,
                this._filter, //hideNotUploaded(this._filter),
                this._entityFields,
                this._sort,
                {
                    Success: resolve,
                    Failure: reject
                }
            )
        );
    }

    _getFeedIdsForSelection(tenantId, selection) {
        return this._EntityDef.loadOsImageIdsForSelection(tenantId, selection);
    }

    getFileEntitiesNameByIds(ids) {
        return this.getEntitiesValueByIdAsProm(ids, "name");
    }

    getEntitiesNameById(ids) {
        let entities = [];
        ids.forEach((id) => {
            if (this._feed.cache[id]) {
                entities.push(this._feed.cache[id].name);
            }
        });
        return entities;
    }

    getImageEntityById(id) {
        return this.getEntityById(id);
    }

    setFilter(query, silent = false) {
        query = query || {};

        const is$userQuery = Object(this._filter).hasOwnProperty("$userQuery");
        const userFilter = is$userQuery ? this._filter.$userQuery : this._filter;
        if (_.isEmpty(query) && _.isEmpty(userFilter)) {
            return;
        }

        this._filter = is$userQuery ? Object.assign({}, this._filter, { $userQuery: query }) : query;

        if (!_.isEmpty(this._pathData)) {
            if (is$userQuery) {
                this._filter.$userQuery = { $and: [this._pathData, this._filter.$userQuery] };
            } else {
                this._filter = { $and: [this._pathData, this._filter] };
            }
        }

        if (!silent) {
            this.reestablish();
        }
    }
}

module.exports = PagingFileFeed;
